import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import RequireAuth from 'src/features/auth/RequireAuth';
import SuspenseFallback from 'src/shared/components/SuspenseFallback';
import AppShell from 'src/shared/components/shell/AppShell';

const LoginPage = lazy(() => import('src/features/auth/LoginPage'));
const ReviewPage = lazy(() => import('src/features/review/ReviewPage'));

/**
 * Top-level split: the login screen and the client's review link render
 * standalone, everything else lives behind the guard inside the app shell.
 *
 * `/cita/:token` is the one screen for someone without an account: the link the
 * salon sends a client over WhatsApp. It is declared here rather than in
 * `shared/routes.ts`, whose routes all render inside the shell.
 *
 * `path="/*"` makes the shell a descendant-route boundary, so `AppContent`
 * keeps owning the feature routes and adding a feature still touches only
 * `shared/routes.ts` and `shell/navItems.ts`.
 */
export default function App() {
  return (
    <Suspense fallback={<SuspenseFallback />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/cita/:token" element={<ReviewPage />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        />
      </Routes>
    </Suspense>
  );
}
